import kebabCase from "lodash/kebabCase";

export const convertTitleToHash = (title: string) => {
  return `#${kebabCase(title)}`;
};
